module.exports = "/images/ergonomics-work-with-laptop-stand.jpg";